export default __webpack_public_path__ + "static/media/aboutus_illustration1.df9c9b7c.gif";